module.exports = __webpack_public_path__ + "img/logo__prepend.fdb9cdc2.svg";